import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { CommonValues } from 'src/app/services/commonValues';
import { CommonModule } from '@angular/common';
import { TruncatePipe } from 'src/app/pipe/TruncatePipe.pipe';

@Component({
  selector: 'app-business-analytics',
  standalone: true,
  imports: [CommonModule, TruncatePipe],
  templateUrl: './business-analytics.component.html',
  styleUrls: ['./business-analytics.component.scss']
})
export class BusinessAnalyticsComponent implements OnInit, OnDestroy {
  // values: {
  //   businessId: any;
  // };

  @Input() commonemit

  businessId: any;
  analytics: any = {
    totFollowers: 3,
    totEmployees: 87876,
    newFollowers: 787,
    pageViews: 76876,
    totPosts: 23434,
    postViews: 234423,
    visitors: 242,
    uniqueVisitors: 23423,
    comments: 234234,
    likes: 23434,
    shares: 234
  }
  clickEventsubscription: Subscription;
  values: any = {}
  businessData: any;
  constructor(private commonvalues: CommonValues, private _activated_route: ActivatedRoute) {
    this.clickEventsubscription = this.commonvalues.getbusinessid().subscribe((res) => {
      this.values = res;
    })
    this._activated_route.queryParams.subscribe(res=>{
      this.businessData = res
    })
  }

  ngOnInit() {
    this.values = this.commonemit
  }

  ngOnDestroy(): void {
    if (this.clickEventsubscription) {
      this.clickEventsubscription.unsubscribe();
    }
  }
}
